<script setup>
import MuxLivestreamPlayer from '@/js/core/components/parts/livestream/MuxLivestreamPlayer.vue';
import VimeoLivestreamPlayer from '@/js/core/components/parts/livestream/VimeoLivestreamPlayer.vue';

defineProps({
  livestreamDetails: {
    type: Object,
    default: () => ({}),
  },
  muxPlaybackId: {
    type: String,
    default: '',
  },
  shouldRenderMuxPlayer: {
    type: Boolean,
    default: false,
  },
  shouldRenderVimeoPlayer: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: '',
  },
});
</script>

<template>
  <div class="event-modal__livestream">
    <MuxLivestreamPlayer v-if="shouldRenderMuxPlayer" :playback-id="muxPlaybackId" :title="title" />
    <VimeoLivestreamPlayer
      v-else-if="shouldRenderVimeoPlayer"
      :embed-url="livestreamDetails.external_embed_url"
      :chat-url="livestreamDetails.chat_url || ''"
      :title="title"
    />
    <div v-else class="event-modal__livestream-placeholder" role="status">
      Livestream will appear here when the stream begins.
    </div>
  </div>
</template>
